export const OSM_TILE_LAYER = {
  URL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  ATTRIBUTION:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};

export const PATH_MAP_DEFAULT_VIEW = {
  LAT: 20.5937,
  LON: 78.9629,
  ZOOM: 5,
};

export const PATH_MAP_POLYLINE = {
  COLOR: '#1278fc',
  WEIGHT: 4,
};

export const STATE_HIGHLIGHT_STYLE = {
  color: '#0c4e8d',
  weight: 3,
  fillColor: '#1278fc',
  fillOpacity: 0.18,
  interactive: false,
};

export const STATE_FIT_BOUNDS = {
  PADDING: 48,
  MAX_ZOOM: 9,
  INITIAL_ZOOM: 7,
};

export const PATH_MAP_MARKER_SIZE = {
  ENDPOINT: 18,
  MID: 10,
  AVATAR: 40,
  AVATAR_PIN: 8,
};

export const PATH_MAP_MARKER_SPREAD_PIXELS = 56;

export const PATH_MAP_AVATAR_FALLBACK = 'U';

export const PATH_MAP_POINT_LABEL = {
  START: 'Start',
  END: 'End',
  ADDRESS: 'Address',
  UPDATED: 'Updated',
};

export const PATH_MAP_FULLSCREEN_LABEL = {
  ENTER: 'View Fullscreen',
  EXIT: 'Exit Fullscreen',
};

export const PATH_MAP_PSEUDO_FULLSCREEN_CLASS = 'path-map--pseudo-fullscreen';
